import { EntityType } from '@/types/entity';

export type HandleOnSortChangeFn = (value: SortOrderValues, isNavigate?: boolean) => void;

export type SortOption = {
  label: string;
  value: SortOrderValues;
};

export type SortOrderOption = {
  label: string;
  value: SortOrderOptions;
};

export type SortState = {
  value: SortOrderValues;
  order: SortOrderOptions;
};

export enum SortOrderOptions {
  ASC = 'asc',
  DESC = 'desc',
}

export enum SortOrderValues {
  CREATED_AT = 'createdAt',
  MANUAL = 'position',
  TRASHED_AT = 'trashedAt',
  NAME = 'name',
  TYPE = 'type',
  COUNT = 'count',
}

export const baseSortOrderOptions: Array<SortOrderOption> = [
  {
    label: 'Ascending ',
    value: SortOrderOptions.ASC,
  },
  {
    label: 'Descending',
    value: SortOrderOptions.DESC,
  },
];

export const baseSortOptions: Array<SortOption> = [
  {
    label: 'Creation date',
    value: SortOrderValues.CREATED_AT,
  },
];

export const nameSortOptions: Array<SortOption> = [
  ...baseSortOptions,
  {
    label: 'Name',
    value: SortOrderValues.NAME,
  },
];

export const albumSortOptions: Array<SortOption> = [
  ...baseSortOptions,
  {
    label: 'Manual order',
    value: SortOrderValues.MANUAL,
  },
];

export const trashSortOptions: Array<SortOption> = [
  ...baseSortOptions,
  {
    label: 'Deletion date',
    value: SortOrderValues.TRASHED_AT,
  },
];

export const shareSortOptions: Array<SortOption> = [
  {
    label: 'Name',
    value: SortOrderValues.NAME,
  },
  {
    label: 'Type',
    value: SortOrderValues.TYPE,
  },
  {
    label: 'Share Count',
    value: SortOrderValues.COUNT,
  },
];

// Per-entity sort options for the management pages. Entities not listed here fall
// back to `baseSortOptions` in SortByValueMenu.
export const sortOptionsByEntity: Partial<Record<EntityType, Array<SortOption>>> = {
  [EntityType.Tag]: nameSortOptions,
};
